import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './i18n/config'; // ← Import BEFORE App
import App from './App';
import reportWebVitals from './reportWebVitals';

// Home Page scrollbar: visible only while actively scrolling, auto-hides
// ~1s after scrolling stops (same idle-hide pattern already used for the
// Restaurant Menu App's own scrollbars — see .is-scrolling in App.css).
// The browser's native page scrollbar has no CSS-only way to react to a
// "currently scrolling" state, so this toggles a class instead. Attached
// once at module scope (not inside a component) so it's active for the
// whole page lifetime regardless of route.
//
// Listens on BOTH window and document.body (capture phase), not just
// window: this app's own CSS gives <body> its own height + overflow-y:
// auto (confirmed by direct testing — document.documentElement never
// grows past the viewport, <body> does all the real scrolling instead),
// so a scroll gesture actually fires its 'scroll' event on the body
// element, not on window/document at all. window stays covered too in
// case a page/template genuinely uses true document-level scrolling
// instead.
let scrollbarHideTimer;
const handlePageScroll = () => {
  document.documentElement.classList.add('is-scrolling');
  document.body.classList.add('is-scrolling');
  clearTimeout(scrollbarHideTimer);
  scrollbarHideTimer = setTimeout(() => {
    document.documentElement.classList.remove('is-scrolling');
    document.body.classList.remove('is-scrolling');
  }, 1000);
};
window.addEventListener('scroll', handlePageScroll, { passive: true });
document.addEventListener('scroll', handlePageScroll, { passive: true, capture: true });

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
